import { inject, Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Subject } from 'rxjs';

import { AbstractLogoutAdaptor } from '../../../common/auth/logout/abstract-logout.adaptor';

@Injectable()
export class LogoutAdaptor extends AbstractLogoutAdaptor {
  private navCtrl = inject(NavController);

  logout$ = new Subject<string>();

  override onLogout(source: string) {
    this.logout$.next(source);
    if (source !== 'guard') {
      this.navCtrl.navigateRoot(['home']);
    }
  }
}
